import { memo, useContext, useState } from 'react';
import { useIntl } from 'react-intl';

import { GeofenceRule } from 'services/resources';

import { updateGeofenceRule } from 'services/Geofences/thunks';

import { FLASH_MESSAGE_TYPES } from 'constants/common';

import { FlashMessageContext } from 'containers/FlashMessageProvider';

import { useAppDispatch } from 'hooks/store';

import { Toggle } from 'components/FormField/styles';

import { getIntlName } from './utils';

const GeofenceToggle = memo(
  ({ geofenceRule }: { geofenceRule: GeofenceRule }) => {
    const [isChecked, setIsChecked] = useState(geofenceRule.isActive);
    const [loading, setLoading] = useState(false);
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const { showFlashMessage } = useContext(FlashMessageContext);

    const name = getIntlName(geofenceRule, intl);

    const toggleChecked = async () => {
      setIsChecked(!isChecked);

      try {
        setLoading(true);
        await dispatch(updateGeofenceRule(geofenceRule.id, { isActive: !geofenceRule.isActive }));
        showFlashMessage(
          FLASH_MESSAGE_TYPES.success,
          intl.formatMessage({ id: 'views.FleetSettings.Geofence.geofenceRuleUpdatedSuccess' }, { name: name })
        );
      } catch (error) {
        showFlashMessage(
          FLASH_MESSAGE_TYPES.error,
          intl.formatMessage({ id: 'views.FleetSettings.Geofence.geofenceRuleUpdatedFailed' }, { name: name })
        );
        setIsChecked(geofenceRule.isActive);
      }
      setLoading(false);
    };

    return (
      <>
        <Toggle type="checkbox" disabled={loading} checked={isChecked} name="toggle" onChange={toggleChecked} />
      </>
    );
  },
  (prev, curr) => prev.geofenceRule.id === curr.geofenceRule.id
);

export default GeofenceToggle;
